import axios from 'axios'
import { getBackendUrl } from './general'


export const crudDirectorio = async (context, typeAction, id, dataRequest) => {
  let response;
  const endPoint = "/archivo/api/directorio/";

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        dataRequest.companyName = dataRequest.companyName ? dataRequest.companyName : `${dataRequest.name1} ${dataRequest.name2} ${dataRequest.lastName1} ${dataRequest.lastName2}`

        Object.keys(dataRequest).forEach(key => {
          if (!dataRequest[key].length) {
            delete dataRequest[key];
          }
        });

        response = await axios.post(
          urlService,
          dataRequest,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        response = await axios.get(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        Object.keys(dataRequest).forEach(key => {
          
          console.log(dataRequest[key]);
          
          if (!dataRequest[key].length) {
            delete dataRequest[key];
          }
        });

        break;
      case "delete":
        response = await axios.delete(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
    }

    // response = await axios.post(
    //   `${source}/archivo/api/directorio/prospecto`,
    //   body,
    //   {
    //     headers: {
    //       'Authorization': `Bearer ${context.$store.state.user.token}`
    //     }
    //   }
    // )

    return response.data;
  } catch (err) {
    throw err.response
  }
}

export const crudDependenciaUsuario = async (context, typeAction, id, requestBody) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    let response
    const endPoint = '/archivo/api/dependenciaUsuario/'
    const { source } = await getBackendUrl()

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${endPoint}`,
          requestBody,
          {
            headers: {
              'Authorization': `Bearer ${context.$store.state.user.token}`
            }
          }
        )    
        break
      case "read":
        response = await axios.get(
          `${source}${endPoint}${id}`,
          {
            headers: {
              'Authorization': `Bearer ${context.$store.state.user.token}`
            }
          }
        )
        break
      case "update":
        response = await axios.put(
          `${source}${endPoint}${id}/`,
          requestBody,
          {
            headers: {
              'Authorization': `Bearer ${context.$store.state.user.token}`
            }
          }
        )
        break
      case "delete":
        response = await axios.delete(
          `${source}${endPoint}${id}/`,
          {
            headers: {
              'Authorization': `Bearer ${context.$store.state.user.token}`
            }
          }
        )    
        break
    }

    return response.data
  } catch (error) {
    console.log(error)
    throw error.response
  }
}

export const crudPedidoCotizacion = async (context, typeAction, id, requestBody) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const endPoint = "/movimientos/api/pedido/";
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };
    let response;

    switch (typeAction) {
      case "create":
        response = await axios.post(
          urlService,
          requestBody,
          {
            headers: paramsHeader
          }
        );
        break;
      case "delete":
        response = await axios.delete(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
    }

    return response.data;
  } catch (err) {
    throw err.response;
  }
}

export const crudMovimientoPedidoCotizacion = async (context, typeAction, id, requestBody) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router);
    const { source } = await getBackendUrl();
    const endPoint = "/movimientos/api/movimientoPedido/";
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };
    let response;

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${urlService}`,
          requestBody,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        break;
      case "update":
        break;
      case "delete":
        response = await axios.delete(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
    }

    return response.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const crudSeguimiento = async (context, typeAction, id, requestBody) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const endPoint = "/mercadeo/api/seguimiento/";
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };
    let response;

    switch (typeAction) {
      case "create":
        response = await axios.post(
          urlService,
          requestBody,
          {
            headers: paramsHeader
          }
        )
        break;
      case "read":
        response = await axios.get(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        break;
      case "patch":
        break;
      case "delete":
        response = await axios.delete(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        )
        break;
    }

    return response.data;
  } catch (err) {
    console.error(err);
    throw err.response;
  }
}

export const crudCalendario = async (context, typeAction, id, requestData) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const endPoint = "/mercadeo/api/calendario/";
    const urlService = `${source}${endPoint}`;
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };
    let response;

    switch (typeAction) {
      case "create":
        response = await axios.post(
          urlService,
          requestData,
          {
            headers: paramsHeader
          }
        )
        break;
      case "read":
        response = await axios.get(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        console.log("ToDo...");
        
        break;
      case "patch":
        break;
      case "delete":
        response = await axios.delete(
          `${urlService}${id}/`,
          {
            headers: paramsHeader
          }
        )
        break;
    }

    return response.data;
  } catch (err) {
    throw err.response;
  }
}
